<template>
  <v-container grid-list-md pa-0 relative>
    <v-layout row wrap>
      <v-flex xs12 sm12>
        <v-card class="primary--border" outlined>
          <v-card-title class="title"
            >Rack
            <v-spacer></v-spacer>
            <add-button
              permission="library-create"
              @action="
                (form.dialog = true), $refs.form ? $refs.form.reset() : '',save_flag=true
              "
            >
              New Rack
            </add-button>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="form.items.data"
            :options.sync="pagination"
            :footer-props="footerProps"
            :server-items-length="form.items.meta.total"
            :loading="form.loading"
          >
            <template v-slot:item="{ index, item }">
              <tr>
                <td>{{ index + form.items.meta.from }}</td>
                <td class="text-xs-left">{{ item.name }}</td>
                <td class="text-xs-left">
                  {{ item.rack_number || "N/A" }}
                </td>
                <td class="text-xs-left">
                  {{ item.location || "N/A" }}
                </td>

                <!-- <td class="text-xs-left">
                  {{ item.description || "N/A" }}
                </td> -->
                <td class="text-right">
                  <edit-button
                    permission="library-update"
                    @agree="form.edit(item), (save_flag = false)"
                  />
                  <delete-button
                    permission="library-delete"
                    @agree="form.delete(item.id)"
                  />
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog v-model="form.dialog" persistent max-width="400px">
        <v-card>
          <v-card-title class="primary white--text">
            <span class="title">Add/Update</span>
          </v-card-title>
          <v-card-text class="pb-1 pt-4">
            <v-form
              ref="form"
              v-model="valid"
              :lazy-validation="lazy"
              @submit.prevent="save"
              @keydown.native="form.errors.clear($event.target.name)"
              @keyup.enter="save"
            >
              <v-text-field
                autocomplete="off"
                label="Rack Name*"
                required
                class="pa-0"
                outlined
                dense
                v-model="form.name"
                name="name"
                :error-messages="form.errors.get('name')"
                :rules="[(v) => !!v || 'Name is required']"
              />
              <v-text-field
                autocomplete="off"
                label="Rack Number"
                class="pa-0"
                outlined
                dense
                v-model="form.rack_number"
              />

              <v-text-field
                autocomplete="off"
                label="Location"
                class="pa-0"
                outlined
                dense
                v-model="form.location"
              />
              <v-textarea
                label="Description"
                no-resize
                rows="3"
                v-model="form.description"
                row-height="15"
                outlined
              ></v-textarea>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="warning"
                  text
                  @click="
                    (form.dialog = false), form.reset(), (save_flag = true)
                  "
                  >Close</v-btn
                >
                <v-btn color="success" text @click="validate" v-if="save_flag"
                  >Save</v-btn
                >
                <v-btn color="success" text @click="validate" v-else
                  >Update</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import Form from "@/library/Form";
import Mixins from "@/library/Mixins";
export default {
  mixins: [Mixins],
  data: () => ({
    valid: true,
    lazy: false,
    save_flag: true,
    form: new Form(
      {
        dialog: false,
        name: "",
        rack_number: "",
        location: "",
        description: "",
      },
      "library/api/rack"
    ),
    headers: [
      { text: "#", align: "left", value: "id", sortable: false },
      { text: "Name", align: "left", value: "name", sortable: false },
      {
        text: "Rack Number",
        align: "left",
        value: "rack_number",
        sortable: false,
      },
      { text: "Location", align: "left", value: "location", sortable: false },
      { text: "Action", align: "right", sortable: false },
    ],
  }),
  watch: {
    pagination: function () {
      this.get();
    },
  },
  methods: {
    get(params) {
      let query = [null, undefined].includes(params)
        ? this.queryString()
        : params;
      this.form.get(null,query).then(({ data }) => {
        this.pagination.totalItems = data.meta.total;
      });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.form.store();
      }
    },
  },
};
</script>